import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'
import type { SATBootcampLearnerOnboardingState } from '@/client/services/satBootcamp/types'

import satBootcampLearnerOnboardingStateFromQuery from './satBootcampLearnerOnboardingStateFromQuery'

export default function useSATBootcampLearnerOnboardingState(): SATBootcampLearnerOnboardingState {
  const query = useQuery()
  const user = useUser()

  return satBootcampLearnerOnboardingStateFromQuery({ query, user })
}
